import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { MatButton } from "@angular/material/button";
import { MatFormField, MatLabel, MatPrefix } from "@angular/material/form-field";
import { MatIcon } from "@angular/material/icon";
import { MatInput } from "@angular/material/input";
import { UsersStore } from "../../../stores/users/users.store";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { ComponentRoutes } from "../../../models/constants/component-routes";
@Component({
    selector: "app-users-search",
    standalone: true,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatFormField,
        MatLabel,
        MatInput,
        MatPrefix,
        MatIcon,
        MatButton,
    ],
    templateUrl: "./user-search.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserSearchComponent {
    private _usersStore: UsersStore = inject(UsersStore);
    private _router: Router = inject(Router);
    private _toastrService: ToastrService = inject(ToastrService);

    public form: FormGroup<{ email: FormControl<string> }> = new FormGroup<{
        email: FormControl<string>;
    }>({
        email: new FormControl<string>("", {
            nonNullable: true,
            validators: [Validators.required],
        }),
    });

    public search(): void {
        this._usersStore.getByEmail(this.form.getRawValue().email).subscribe({
            next: (user) =>
                this._router.navigateByUrl(
                    ComponentRoutes.users.user.replace(":email", user.email),
                ),
            error: (error) => this._toastrService.error(error.error.description),
        });
    }
}
